<template>
  <b-card class="rounded-xl">
    <modal :show.sync="editModal" header-classes="bg-primary p-3">
      <h6 slot="header" class="modal-title text-white font-semibold pt-1">
        EDIT IMAGE ORDER
      </h6>
      <EditTagsDetail />
      <template slot="footer">
        <base-button type="primary">SAVE CHANGES</base-button>
        <base-button type="secondary" class="ml-auto" @click="editModal = false"
          >CLOSE</base-button
        >
      </template>
    </modal>
    <modal :show.sync="categoryModal" header-classes="bg-primary p-3" size="lg">
      <h6 slot="header" class="modal-title text-white font-semibold pt-1">
        Category
      </h6>
      <CategoryTable />
      <template slot="footer">
        <base-button type="primary">SAVE CHANGES</base-button>
        <base-button
          type="secondary"
          class="ml-auto"
          @click="categoryModal = false"
          >CLOSE</base-button
        >
      </template>
    </modal>
    <AddTagsSidebar
      :isSidebarActive="openAddBannerSidebar"
      @closeSidebar="toggleAddBannerSidebar"
    />
    <div class="justify-between  items-center">
      <h2 class="text-2xl font-semibold">
        Store Listing
      </h2>

      <!-- <small class=" text-muted "
          >Lorem ipsum dolor sit amet, consectetur adipiscing elit,
        </small> -->
      <OrderStatus />
    </div>
    <!-- <base-button outline type="success" class="flex" @click="addBanner">
        <feather-icon icon="PlusIcon" class="mr-1"></feather-icon>Add Store
      </base-button> -->
    <b-input-group class="mt-12">
      <b-form-input
        class="border-none shadow-lg"
        type="text"
        min="0.00"
        placeholder="Enter Search...."
      ></b-form-input>

      <b-input-group-append>
        <b-button
          variant="white"
          class="flex items-center shadow-lg"
          aria-label="search"
        >
          <feather-icon
            class=" cursor-pointer  mr-2"
            icon="SearchIcon"
            svgClasses="w-4 h-4"
          ></feather-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <el-table
      class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
      header-row-class-name="thead-light table-th-color"
      :data="TagsData"
    >
      <el-table-column
        label="StoreID"
        prop="vendorid"
        min-width="120px"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.vendorid }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Name" min-width="150px" prop="name" sortable>
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.name }}</span>
        </template>
      </el-table-column>

      <el-table-column label="Email" min-width="180px" prop="email" sortable>
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.email }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="Category"
        min-width="150px"
        prop="category"
        sortable
      >
        <p
          class="cursor-pointer text-blue font-medium underline text-sm"
          @click="categoryModal = true"
        >
          View
        </p>
        <!-- <feather-icon
          @click="categoryModal = true"
          block
          icon="EditIcon"
          svgClasses="w-5"
        ></feather-icon> -->
      </el-table-column>
      <el-table-column
        label="Default Commission Type"
        prop="commissiontype"
        min-width="140px"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.commissiontype }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Currency"
        prop="currency"
        min-width="140px"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.currency }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Default Commission Fee"
        prop="discount"
        min-width="140px"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.discount }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Status" min-width="150px" prop="status" sortable>
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.status }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="Store Status"
        min-width="200px"
        prop="vendorshopstatus"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{
            row.vendorshopstatus
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Date added"
        min-width="150px"
        prop="dateadded"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.dateadded }}</span>
        </template>
      </el-table-column>
      <!-- 
      <el-table-column
        label="Sub Tags"
        min-width="170px"
        prop="orderno"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.subtags }}</span>
        </template>
      </el-table-column> -->

      <el-table-column label="Action" min-width="150px">
        <div class="flex items-center">
          <div
            class="flex items-center mr-4 cursor-pointer"
            data-toggle="tooltip"
            data-placement="top"
            title="Edit"
          >
            <feather-icon
              @click="editModal = true"
              block
              icon="EditIcon"
              svgClasses="w-5"
            ></feather-icon>
          </div>
          <div
            class="flex items-center cursor-pointer "
            data-toggle="tooltip"
            data-placement="top"
            title="Enable/Disable"
          >
            <feather-icon
              icon="MinusCircleIcon"
              svgClasses="w-5"
              variant="primary"
            ></feather-icon>
          </div>
        </div>
      </el-table-column>
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        v-model="currentPage"
        :per-page="10"
        :total="50"
      ></base-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import "../../scss/Index.scss";
import TagsData from "./components/TagsData";
import EditTagsDetail from "./components/EditTagsDetail";
import CategoryTable from "./components/CategoryTable";
import AddTagsSidebar from "./components/AddTagsSidebar";
import OrderStatus from "./components/OrderStatus";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    EditTagsDetail,
    CategoryTable,
    AddTagsSidebar,
    OrderStatus
  },
  data() {
    return {
      TagsData,
      currentPage: 1,
      editModal: false,
      categoryModal: false,
      openAddBannerSidebar: false
    };
  },
  methods: {
    addBanner() {
      this.toggleAddBannerSidebar(true);
    },
    toggleAddBannerSidebar(val = false) {
      this.openAddBannerSidebar = val;
    }
  }
};
</script>
